import Vue from 'vue'
import VueRouter from 'vue-router'
import Template from './pages/template'
import Dashboard from './pages/dashboard/index'
import Fermenters from './pages/fermenters/index'
import Settings from './pages/settings/index'
import Simulators from './pages/simulators/index'
import Contacts from './pages/contact/index'
import Ferments from './pages/ferments/index'
import SiteSelection from './pages/site-selection/index'
import FermentProfiles from './pages/profiles/index'
import History from './pages/history/index'
import Authorize from './pages/auth/authorize'
import Login from './pages/auth/login'
import Logout from './pages/auth/logout'
import Register from './pages/auth/register'

Vue.use(VueRouter);

let Router = new VueRouter({
	hashbang: false,
	history: true
});

Router.map({
	'/': {
		component: Template,
		subRoutes: {
			'/': {
				component: Dashboard,
				name: 'dashboard'
			},
			'/tank-group/:tankGroupId': {
				component: Dashboard,
				name: 'dashboard.tank-group'
			},
			'bulk-entry': {
				component: Dashboard,
				name: 'dashboard.bulk-entry'
			}
		}
	},
	'/fermenters': {
		component: Template,
		subRoutes: {
			'/': {
				component: Fermenters,
				name: 'fermenters.index'
			}
		}
	},
	'/settings': {
		component: Template,
		subRoutes: {
			'/': {
				component: Settings,
				name: 'settings.index'
			}
		}
	},
	'/simulator-setup': {
		component: Template,
		subRoutes: {
			'/': {
				component: Simulators,
				name: 'simulators.index'
			}
		}
	},
	'/contact': {
		component: Template,
		subRoutes: {
			'/': {
				component: Contacts,
				name: 'contact.index'
			}
		}
	},
	'/ferments': {
		component: Template,
		subRoutes: {
			'/:fermenterId/:fermentId': {
				component: Ferments,
				name: 'ferments.index'
			},
			'/:fermenterId/:fermentId/what-if': {
				component: Ferments,
				name: 'ferments.what-if'
			},
			'/:fermenterId/:fermentId/what-now': {
				component: Ferments,
				name: 'ferments.what-now'
			}
		}
	},
	'/profiles': {
		component: Template,
		subRoutes: {
			'/': {
				component: FermentProfiles,
				name: 'profiles.index'
			}
		}
	},
	'/site-selection': {
		hideNavigation: true,
		component: Template,
		subRoutes: {
			'/': {
				component: SiteSelection,
				name: 'site-selection.index'
			}
		}
	},
	'/history': {
		component: Template,
		subRoutes: {
			'/': {
				component: History,
				name: 'history.index'
			}
		}
	},
	'/oauth': {
		component: Template,
		hideNavigation: true,
		subRoutes: {
			'/authorize': {
				component: Authorize,
				name: 'oauth.authorize'
			}
		}
	},
	'/login': {
		component: Template,
		hideNavigation: false,
		subRoutes: {
			'/': {
				component: Login,
				name: 'login'
			}
		}
	},
	'/logout': {
		component: Template,
		hideNavigation: true,
		subRoutes: {
			'/': {
				component: Logout,
				name: 'logout'
			}
		}
	},
	'/register': {
		component: Template,
		hideNavigation: false,
		subRoutes: {
			'/': {
				component: Register,
				name: 'register'
			}
		}
	},
});

Router.alias({
	'/ferments/:fermenterId': '/ferments/:fermenterId/0'
});

import store from 'vx/store'
import * as types from 'vx/mutation-types'
import { User as UserActions } from 'vx/actions'
import { config } from './config'

Router.beforeEach(({ to, next, redirect }) => {
	// Remove any window resize event bindings. These need to be bound
	// every time a route is loaded if they are required.
	$(window).off('resize');

	if (to.name != 'ferments.index') {
		localStorage.setItem('scrolledState', JSON.stringify({ top: 0, left: 0 }));
	}

	// Handle the results of authorization with or without success
	let authCallback = () => {

		// For now only the login and register pages are available when logged out
		if(!isAuthorized && to.name !== 'login' && to.name !== 'register'){
			redirect({ name: 'login' });
		}

		// Before transitioning check to see if an active site has been set.
		// If not, and if we aren't already on the site selection page, we
		// will redirect them to the site selection page. Before that we
		// will check to see if we have an active site stored in the
		// session storage, if so, we'll set that as the active site
		// and then continue with the transition.
		if ($.isEmptyObject(store.state.sites.active) && to.name !== 'site-selection.index' && to.name !== 'oauth.authorize' && to.name !== 'login' && to.name !== 'register') {
			let site = JSON.parse(localStorage.getItem('site'));
			
			if (!$.isEmptyObject(site)) {
				store.dispatch(types.SET_SITE, site);
			} else {
				redirect({ name: 'site-selection.index' });
			}
		}

		next();
	};

	// If we do not have an authorized user then we'll attempt to sign them
	// in with the token we have in session storage.
	let token = sessionStorage.getItem('token');

	// Pre-emptive authorization, we need to do some form of this every page change via the token even when logged in to refresh the user
	var isAuthorized = store.state.user.authorized && token; // In rare cases these will both be set like on fresh login
	if (!isAuthorized && !store.state.user.authorized && token && to.name !== 'login' && to.name !== 'register' ){
		// This is reauthorization using a still-present token
		UserActions.authorize(store, token).then(response => {
			isAuthorized = true;
			authCallback();
		}, response => {
			// Reauthing with previous token simply failed, so back to login
			redirect({ name: 'login' });
		});
	} else {
		authCallback();
	}
});

export default Router;



// WEBPACK FOOTER //
// ./src/routes.js